import { RenderIf } from '../../helpers/RenderIf';
import React, { useEffect, useRef, useState } from 'react';
import { T } from '../../traks';
import "./styles.css"

const TwoFaInputs = ({ confirmAuthCode }) => {
	const [digits, setDigits] = useState(["", "", "", "", "", ""]);
	const inputRefs = useRef([]);

	useEffect(() => {
		inputRefs.current[0].focus();
	}, []);

	useEffect(() => {
		if (digits.filter(el => el !== "").length === 6) {
			setTimeout(() => {
				const authCode = digits.join("")
				confirmAuthCode({ auth_code: authCode })
			}, 500);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [digits])

	const handleKeyDown = (index, event) => {
		if (event.key >= 0 && event.key <= 9) {
			const newDigits = [...digits];
			newDigits[index] = event.key;
			setDigits(newDigits);
			if (index < 5) {
				inputRefs.current[index + 1].focus();
			}
			event.preventDefault();
		} else if (event.key === 'Backspace') {
			const newDigits = [...digits];
			newDigits[index] = '';
			setDigits(newDigits);
			if (index > 0) {
				inputRefs.current[index - 1].focus();
			}
			event.preventDefault();
		}
	};

	const handlePaste = (event) => {
		const pastedText = event.clipboardData.getData('text/plain').trim();
		const pastedDigits = pastedText.split('').slice(0, 6);
		const newDigits = [...digits];
		pastedDigits.forEach((digit, index) => {
			newDigits[index] = digit;
			if (index < 5) {
				inputRefs.current[index + 1].focus();
			}
		});
		setDigits(newDigits);
		event.preventDefault();
	};

	return (
		<div className="d-flex" style={{ maxWidth: "100vw" }}>
			{digits.map((digit, index) => (
				<div className="two_fa_input border_radius_6px mx-2 d-flex" key={index+"tfi"}>
					<input
						type="text"
						className="text-center fs-4"
						style={{ width: "100%", height: "100%" }}
						key={index}
						value={digit}
						maxLength={1}
						ref={(ref) => (inputRefs.current[index] = ref)}
						onKeyDown={(e) => handleKeyDown(index, e)}
						onPaste={(e) => handlePaste(e)}
					/>
				</div>
			))}
		</div>
	);
}

const CodeSent = ({ confirmAuthCode, invalidCode, userAuth, sendCode }) => {
	return (
		<>
			<div>
				<div className="fs-5 fw_600">
					<T>Insert the 6 digit code you received on </T>
					<br />
					{userAuth.picked_two_method.data}
				</div>
				<div className="txt_grey_4 fw_500 mt-3">
					<T>This helps us keep your account safe
						<br />
						and to verify your identity</T>
				</div>
			</div>
			<div className="fs-3 light-grey-text fw_500 mt-5 mb-3">
				<T>Enter 2-step verification code</T>
			</div>
			{invalidCode && <div className="fs-3"><T>Incorrect code</T></div>}
			<div className="d-flex justify-content-center">
				<TwoFaInputs confirmAuthCode={confirmAuthCode} />
			</div>
			<button className="btn btn_green mt-5 mb-3 px-3 py-2" onClick={() => sendCode(userAuth)}>
				<T>Receive a new code</T>
			</button>
		</>
	)
}

const TwoFaMethodBox = ({ onClick, src, children = null }) => {
	const twofaBoxStyle = { backgroundColor: "#F9FBFD" }
	if (window.innerWidth > 500)
		twofaBoxStyle["width"] = "250px"
	return (
		<div
			className="two_method_box sibilus_border border_radius_6px cursor_pointer mb-4 d-flex flex-column justify-content-center align-items-center"
			style={twofaBoxStyle}
			onClick={onClick}
		>
			<div>
				<img src={src} className="two_factor_icon" alt="two-factor-icon" />
			</div>
			<RenderIf condition={children}>
				<div className="mt-3">
					{children}
				</div>
			</RenderIf>
		</div>

	)


}

const ChooseTwoFaMethod = ({ userAuth, sendCode }) => {
	const [showPhoneNumbers, setShowPhoneNumbers] = useState(false)
	const [showEmails, setShowEmails] = useState(false)
	const phones = userAuth.two_fa_methods.phone_numbers
	const emails = userAuth.two_fa_methods.emails
	const name = userAuth["name"] || null

	const handlePickMethod = (method) => {
		userAuth["picked_two_method"] = method
		delete userAuth["two_fa_methods"]
		sendCode(userAuth)
	}

	const phoneOnClick = () => {
		if (phones.length === 1)
			handlePickMethod({ type: "phone", company_id: phones[0].company_id, data: phones[0].obfuscated_phone_number })

		setShowPhoneNumbers(true)
	}
	const emailOnClick = () => {
		if (emails.length === 1)
			handlePickMethod({ type: "email", company_id: emails[0].company_id, data: emails[0].obfuscated_email })

		setShowEmails(true)
	}

	return (<>
		<div>
			<h3 className="mt-5">
				<RenderIf condition={!name}>
					<T>2-step Verification</T>
				</RenderIf>
				<RenderIf condition={name}>
					<T>Hi</T> {name}
				</RenderIf>
			</h3>
			<div className="txt_grey">
				<div>
					<T>For security reasons we will send you a code</T>
					<br />
					<T>which you will need in order to login.</T>
				</div>
				<div className="mt-3">
					<T>How would you like to receive the code?</T>
				</div>
			</div>
		</div>
		<div className="w-100 px-sm-5 d-flex justify-content-center align-items-center mt-5">
			<RenderIf condition={!showPhoneNumbers && !showEmails}>
				<RenderIf condition={phones.length > 0 && !showPhoneNumbers}>
					<div className="pe-3">
						<TwoFaMethodBox
							src="https://static.sibilus.eu/gfx/twofa-phone-icon-0.svg"
							onClick={phoneOnClick}
						>
							<T>Receive code</T>
							<br /> 
							<T>in an SMS text</T>
							<RenderIf condition={phones.length === 1}>
								<div className="mt-4 b">
									{phones.length > 0 && phones[0]["obfuscated_phone_number"]}
								</div>
							</RenderIf>
						</TwoFaMethodBox>
					</div>
				</RenderIf>
				<RenderIf condition={emails.length > 0 && !showEmails}>
					<div>
						<TwoFaMethodBox
							src="https://static.sibilus.eu/gfx/twofa-email-icon-0.svg"
							onClick={emailOnClick}
						>
							<T>Receive code</T>
							< br /> 
							<T>in an email</T>
							<RenderIf condition={emails.length === 1}>
								<div className="mt-4 b">
									{emails.length > 0 && emails[0]["obfuscated_email"]}
								</div>
							</RenderIf>
						</TwoFaMethodBox>
					</div>
				</RenderIf>
			</RenderIf>
			<RenderIf condition={showPhoneNumbers}>
				<div className="d-flex flex-column w-100">
					{phones.map((phone, index) =>
						<div
							className="sibilus_border border_radius_6px py-4 my-3 cursor_pointer"
							style={{ backgroundColor: "#F9FBFD" }}
							onClick={() => handlePickMethod({ type: "phone", company_id: phone.company_id, data: phone.obfuscated_phone_number })}
							key={index + "p"}
						>
							{phone.obfuscated_phone_number}
						</div>
					)}
				</div>
			</RenderIf>
			<RenderIf condition={showEmails}>
				<div className="d-flex flex-column w-100">
					{emails.map((email, index) =>
						<div
							className="sibilus_border border_radius_6px py-4 my-3 cursor_pointer"
							style={{ backgroundColor: "#F9FBFD" }}
							onClick={() => handlePickMethod({ type: "email", company_id: email.company_id, data: email.obfuscated_email })}
							key={index + "e"}
						>
							{email.obfuscated_email}
						</div>
					)}
				</div>
			</RenderIf>
		</div>
	</>)
}



const TwoFactorAuthentication = ({
	codeStatus,
	sendCode,
	confirmAuthCode,
	userAuth = undefined,
	cancel = null,
	className=null
}) => {
	const classList = `bg-white border_radius_6px d-flex flex-column align-items-center${className ? " "+className : ""}`
	return (
		<div className={classList} style={{ minWidth: "70%" }}>
			<RenderIf condition={codeStatus === undefined}>
				<div>
					<ChooseTwoFaMethod
						userAuth={userAuth}
						sendCode={sendCode}
					/>
					<RenderIf condition={cancel}>
						<div className="primary cursor_pointer fw_500" onClick={cancel}>
							<T>Cancel Login</T>
						</div>
					</RenderIf>

				</div>
			</RenderIf>
			<RenderIf condition={codeStatus !== undefined}>
				<div>
					<CodeSent
						invalidCode={codeStatus === "invalid code"}
						confirmAuthCode={confirmAuthCode}
						userAuth={userAuth}
						sendCode={sendCode}
					/>
				</div>
			</RenderIf>
			<div></div>
		</div>
	);
};

export default TwoFactorAuthentication;
